import { Component, HostListener, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { ConstantsApplication } from './shared/utils/ConstantsApplication';
import { GlobalLoadingBannerComponent } from './shared/global-loading-banner/global-loading-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, GlobalLoadingBannerComponent],
  /** Inline: evita falsos positivos NG8113 con `templateUrl` y garantiza que `RouterOutlet` se enlace al compilar. */
  template: `
    <router-outlet></router-outlet>
    <app-global-loading-banner></app-global-loading-banner>
    <p-toast position="bottom-right" key="tr-main"></p-toast>
  `,
  styleUrl: './app.css',
  providers: [MessageService]
})
export class App implements OnInit {

  constructor(
    private location: Location,
    private titleService: Title,
    private router: Router) {
    console.log('environment is production', environment.production);
  }

  ngOnInit() {
    this.titleService.setTitle(this.getTitle());
    this.router.navigate(['/login']);
    console.log('navigate to login')
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'F1' || event.key === 'F2' || event.key === 'F3' || event.key === 'F4' ||
      event.key === 'F5' || event.key === 'F6' || event.key === 'F7' || event.key === 'F8' ||
      event.key === 'F9' || event.key === 'F10' || event.key === 'F11' || event.key === 'F12') {
      console.log('into HostListener AppComponent onKeyDown, key function press', event.key);
      event.preventDefault();
    }
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent): void {
    console.log('into HostListener AppComponent contextmenu, evita el menú contextual del botón derecho');
    event.preventDefault();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
  }

  getTitle() {
    return this.getDomain().split('.')[0].toUpperCase() + ' ' + this.version();
  }

  version() {
    return ConstantsApplication.VERSION_ORIGIN;
  }

  getDomain() {
    const url = this.location.prepareExternalUrl(this.location.path());
    const parser = document.createElement('a');
    parser.href = url;
    return parser.hostname;
  }

}
